var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "var(--c-basic-black)",
    clipPath: "url(#close_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m22.125 9.875-12.25 12.25M9.875 9.875l12.25 12.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.001 29.333c7.364 0 13.334-5.97 13.334-13.333S23.365 2.667 16 2.667 2.668 8.636 2.668 16s5.97 13.333 13.333 13.333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "close_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-basic-white)",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgClose;